import { colorSet } from '@components/Provider';
import { Theme } from '@material-ui/core';
import {
  CSSProperties,
  CreateCSSProperties
} from '@material-ui/core/styles/withStyles';
import {
  CHAT_INPUT_TOTAL_HEIGHT,
  CHAT_MOBILE_TOTAL_INPUT_HEIGHT,
  CHAT_INPUT_HEIGHT
} from '../../constants';

type StyleSheetType = CSSProperties | CreateCSSProperties<{}>;

const ChatMessageInputStyleSheet = (
  isMobile: string,
  theme: Theme
): StyleSheetType => {
  return {
    height: CHAT_INPUT_TOTAL_HEIGHT,
    [isMobile]: {
      height: CHAT_MOBILE_TOTAL_INPUT_HEIGHT
    },
    '& .message-buttons': {
      height: 42,
      width: '100%',
      backgroundColor: colorSet.gray100,
      borderTop: `1px solid ${colorSet.gray400}`,
      [isMobile]: {
        display: 'none'
      }
    },
    '& .message-input': {
      display: 'flex',
      alignItems: 'center',
      height: CHAT_INPUT_HEIGHT,
      width: '100%',
      backgroundColor: colorSet.gray000,
      padding: 0,
      borderTop: 'none',
      '& #shadow-root': {
        color: colorSet.errorBase
      },
      '& .bypass-warning': {
        border: `1px solid ${colorSet.errorMain} !important`
      },
      [isMobile]: {
        height: CHAT_MOBILE_TOTAL_INPUT_HEIGHT,
        padding: '8px 16px 8px 4px',
        borderTop: `1px solid ${colorSet.gray400}`
      },
      '& .noBorder': {
        border: 'none'
      },
      '& .multiline': {
        height: 100,
        [isMobile]: {
          height: 'auto'
        }
      },
      '& .MuiIconButton-root ': {
        width: 32,
        height: 32
      },
      '& .inputBorder': {
        border: `1px solid ${colorSet.gray400}`,
        borderRadius: 0,
        [isMobile]: {
          borderRadius: 16
        }
      },
      '& .inputEndIcon': {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 68,
        height: 68,
        border: `1px solid ${colorSet.gray400}`,
        borderRadius: 16,
        backgroundColor: colorSet.gray100,
        cursor: 'pointer',
        '& .MuiTypography-body2': {
          color: colorSet.gray500
        }
      }
    }
  };
};

export default ChatMessageInputStyleSheet;
